/** Drops the cabinet session and loads the login page: a signed-out visitor has no other route, so reloading in place shows a 404. */
export default function logout(): void {
  window.localStorage.clear();

  window.location.assign('/');
}
